import type { OneDriveFileType } from '../services/OneDriveAPIs/OneDriveTypes.ts';

export const handleBulkExport = async (
	documents: any[],
	exportFn: (document: any, isBulk: boolean) => Promise<File | null>,
): Promise<File[]> => {
	const files = await Promise.allSettled(
		documents.map(async (doc: OneDriveFileType) => {
			return exportFn(doc, true);
		}),
	);
	// @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
	return files.filter((res) => res.status === 'fulfilled').map((res) => res.value);
};
